import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BasketPopup from "./BasketPopup";
import WhishList from "./WhishList";

const NavBar = () => {
  const navigate = useNavigate();
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupWhish, setPopupWhish] = useState(false);
  const [q, setQ] = useState("");
  const cart = JSON.parse(localStorage.getItem("cart")) || [];
  const hasItemsInCart = cart.length > 0;

  const submitSearch = (e) => {
    if (e.key === "Enter") navigate(`/Category${q ? `?q=${encodeURIComponent(q)}` : ""}`);
  };

  return (
    <header className="oot-nav">
      <div className="oot-nav-inner">
        <div className="oot-brand" onClick={() => navigate("/")}>
          <span className="oot-brand-dot" />Oot<span>lob</span>
        </div>

        <nav className="oot-nav-links">
          <button className="oot-nav-link" onClick={() => navigate("/")}>Home</button>
          <button className="oot-nav-link" onClick={() => navigate("/Category")}>Shop</button>
        </nav>

        <div className="oot-search">
          <svg viewBox="0 0 24 24" fill="none" stroke="#9aa1ad" strokeWidth="2" width="18" height="18">
            <circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" strokeLinecap="round" />
          </svg>
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={submitSearch}
            placeholder="Search products…" />
        </div>

        <div className="oot-nav-icons">
          <button className="oot-icon-btn" title="Wishlist" onClick={() => setPopupWhish(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1.1 1L12 21l7.7-7.6 1.1-1a5.5 5.5 0 0 0 0-7.8z" />
            </svg>
          </button>
          <button className="oot-icon-btn" title="Account" onClick={() => navigate("/Login")}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" />
            </svg>
          </button>
          <button className="oot-icon-btn" title="Cart" onClick={() => setPopupOpen(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="20" r="1.6" /><circle cx="18" cy="20" r="1.6" />
              <path d="M2 3h2.2l2.3 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L21 7H5.5" />
            </svg>
            {hasItemsInCart && <span className="oot-cart-dot" />}
          </button>
        </div>
      </div>

      <WhishList isOpen={popupWhish} onClose={() => setPopupWhish(false)} />
      <BasketPopup isOpen={popupOpen} onClose={() => setPopupOpen(false)} />
    </header>
  );
};

export default NavBar;
